import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const notifications = [{
  flagCode: 'us',
  countryName: 'United States',
  location: 'New York, USA',
  name: 'Sarah Jenkins',
  initials: 'SJ',
  time: '5 minutes ago'
}, {
  flagCode: 'gb',
  countryName: 'United Kingdom',
  location: 'London, UK',
  name: 'David Smith',
  initials: 'DS',
  time: '12 minutes ago'
}, {
  flagCode: 'ca',
  countryName: 'Canada',
  location: 'Toronto, Canada',
  name: 'Emily Chen',
  initials: 'EC',
  time: '18 minutes ago'
}, {
  flagCode: 'au',
  countryName: 'Australia',
  location: 'Sydney, Australia',
  name: 'Michael Brown',
  initials: 'MB',
  time: '27 minutes ago'
}, {
  flagCode: 'ie',
  countryName: 'Ireland',
  location: 'Dublin, Ireland',
  name: 'Jessica Walsh',
  initials: 'JW',
  time: '41 minutes ago'
}];
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const timer = window.setTimeout(() => setIsVisible(true), 3000);
    return () => window.clearTimeout(timer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    const hideTimer = window.setTimeout(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        if (!isDismissed) {
          setCurrentIndex(previous => (previous + 1) % notifications.length);
          setIsVisible(true);
        }
      }, 1500);
    }, 5000);
    return () => window.clearTimeout(hideTimer);
  }, [currentIndex, isDismissed, isVisible]);
  if (isDismissed) return null;
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 pointer-events-none w-full px-4 flex justify-center" aria-live="polite" data-id="element-234" data-mp="3j9dshyqbmw9z">
      <AnimatePresence mode="wait" data-id="element-235" data-mp="3koybtks0z3t7">
        {isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border border-sand-deep rounded-xl p-3.5 shadow-[0_10px_30px_-12px_rgba(23,23,26,0.45)] w-full max-w-[360px] pointer-events-auto relative" data-id="element-236" data-mp="3pokqlyni4s44">
            <button type="button" onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-warmgray hover:text-charcoal transition-colors duration-150 ease-out" aria-label="Close notification" data-id="element-237" data-mp="2s2nag7wlgyvc">
              <XIcon size={14} aria-hidden="true" data-id="element-238" data-mp="2n2slwb0akldg" />
            </button>
            <div className="flex items-center gap-3" data-id="element-239" data-mp="2n54zyd2xibl8">
              <div className="relative shrink-0" data-id="element-240" data-mp="24dyo2x4ncne3">
                <div className="w-11 h-11 rounded-full bg-charcoal flex items-center justify-center text-orange font-bold text-sm" data-id="element-241" data-mp="24gl47l5lsb7x">
                  {current.initials}
                </div>
                <img src={`https://flagcdn.com/w40/${current.flagCode}.png`} alt={`${current.countryName} flag`} className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full object-cover border-2 border-white shadow" data-id="element-242" data-mp="2ddbuti1dyxv4" />
              </div>
              <div className="flex-1 min-w-0 pr-4" data-id="element-243" data-mp="2icotr15j7ve2">
                <div className="flex items-center gap-1.5 text-[11px] text-warmgray mb-0.5" data-id="element-244" data-mp="2w4uyzs75chyq">
                  <img src={`https://flagcdn.com/w20/${current.flagCode}.png`} alt="" className="w-4 h-3 rounded-sm object-cover" data-id="element-245" data-mp="2s5dr6s48z8qe" />
                  <span className="truncate" data-id="element-246" data-mp="316bx5fy8xqbm">{current.location}</span>
                </div>
                <p className="text-charcoal text-[13px] leading-snug" data-id="element-247" data-mp="3l62fsz9y7iu9">
                  <span className="font-bold" data-id="element-248" data-mp="3p8gy9i9pggl0">{current.name}</span>{' '}
                  <span className="text-warmgray" data-id="element-249" data-mp="3p6mdq52ciqhg">
                    purchased Hybrid Race Coach Ready
                  </span>
                </p>
                <div className="flex items-center gap-1.5 text-[10px] text-orange font-medium mt-1" data-id="element-250" data-mp="2te3waen4n35">
                  <span className="w-1.5 h-1.5 rounded-full bg-orange" data-id="element-251" data-mp="329b00ztm7luy" />
                  <ShoppingBagIcon size={10} aria-hidden="true" data-id="element-252" data-mp="369l1q0adjq40" />
                  <span data-id="element-253" data-mp="36bxjodg4u0h2">Verified purchase • {current.time}</span>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}